<template>
  <TableBlock :data="computedData.data" :forcedTransport="forcedTransport" />
</template>

<script>
import Computing from '@/components/Analysis/Computing';
import TableBlock from '@/components/Table/';

export default {
  components: {
    TableBlock,
  },

  mixins: [Computing],

  props: {
    data: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: false,
      default: -1,
    },

    range: {
      type: Array,
      required: false,
      default: () => [0, 10],
    },

    export: {
      type: Boolean,
      required: false,
      default: false,
    },

    forcedTransport: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
